<template>
  <div
    :style="'height: 100%; background: ' + backgroundColor"
    :class="getCardClass()"
  >
    <v-card :elevation="flat ? 0 : 1" :class="getItemClass()" @click="click">
      <div class="d-flex align-center justify-start" v-if="!infoFooter">
        <div class="md-light" v-if="title">{{ title }}</div>
        <v-spacer />
        <slot name="actions" class="item-actions" />
      </div>
      <div class="d-flex align-start justify-start">
        <div class="d-flex align-start justify-start">
          <div class="item-info">
            <v-row class="info-row">
              <v-col
                cols="6"
                md="3"
                v-for="(header, index) in formattedHeaders"
                :key="header + '_' + index"
                class="pb-3 pt-3 pr-1"
                :style="hideIfEmpty(item, header.value)"
              >
                <div v-if="getTableDataItem(item, header.value)">
                  <div
                    :class="getTableHeaderClass()"
                    v-if="!hideHeader(item, header.value)"
                  >
                    {{ header.text }}
                  </div>
                  <div :class="getTableDataClass()">
                    {{ getTableDataItem(item, header.value) }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <div class="d-flex align-center justify-start" v-if="infoFooter">
        <div class="md-light" v-if="title">{{ title }}</div>
        <v-spacer />
        <slot name="actions" class="item-actions" />
      </div>
    </v-card>
    <v-divider v-if="flat" />
    <v-divider v-if="isItemFooter(item)" />
  </div>
</template>

<script>
import store from "@/store";

import helpers from "@/mixins/helpers";

export default {
  components: {},
  mixins: [helpers],

  props: {
    headers: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    infoType: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "#FFFFFF",
    },
    teaseInfo: {
      type: Boolean,
      required: false,
      default: false,
    },
    bold: {
      type: Boolean,
      required: false,
      default: false,
    },
    flat: {
      type: Boolean,
      required: false,
      default: false,
    },
    infoFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {};
  },

  computed: {
    formattedHeaders() {
      let headers = [];
      if (this.teaseInfo && this.headers) {
        for (let index = 0; index < 2; index++) {
          const header = this.headers[index];
          if (header) {
            headers.push(header);
          }
        }

        return headers;
      } else {
        return this.headers;
      }
    },
  },

  watch: {},

  mounted() {},

  methods: {
    getTableHeaderClass() {
      if (this.bold) {
        return "md-light overflow-ellipsis";
      } else {
        return "field-header overflow-ellipsis";
      }
    },

    getCardClass() {
      if (this.isItemFooter(this.item)) {
        if (this.flat) {
          return "flat-item-footer";
        } else {
          return "item-footer";
        }
      } else {
        if (this.flat) {
          return "flat-table-item-card";
        } else {
          return "table-item-card";
        }
      }
    },

    getItemClass() {
      if (this.flat) {
        return "flat-item-card";
      } else {
        return "item-card";
      }
    },

    getTableDataClass() {
      if (this.bold) {
        return "md-body-bold-no-spacing overflow-ellipsis";
      } else {
        return "field-value overflow-ellipsis";
      }
    },

    isItemFooter(item) {
      let value = false;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          const element = item[key];
          if (element == "Totals" && this.infoType == "report") {
            value = true;
          }
        }
      }
      return value;
    },
    hideHeader(item, headerValue) {
      if (Object.keys(item).length == 2) {
        return true;
      } else if (
        this.infoType == "report" &&
        this.getTableDataItem(item, headerValue) == "Totals"
      ) {
        return true;
      } else {
        return false;
      }
    },
    hideIfEmpty(item, headerValue) {
      if (this.getTableDataItem(item, headerValue) == "") {
        return "display: none;";
      } else {
        return "";
      }
    },
    click() {
      this.$emit("click");
    },
    getTableDataItem(item, headerValue) {
      if (this.infoType == "order") {
        if (headerValue === "_jv.id") {
          return item._jv.id;
        } else if (headerValue === "Location") {
          let field = headerValue.substring(16);
          if (item.checkout_fields[field] == "Shopper Address") {
            return;
          }
        } else {
          let field = headerValue.substring(16);
          return item.checkout_fields[field]
            ? item.checkout_fields[field]
            : "None";
        }
      } else if (item[headerValue]) {
        return item[headerValue];
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.item-info {
  width: 100%;
}

.item-card {
  width: 100%;
  padding: 16px;
  border-radius: 5px;
  background: white;
}

.item-actions {
  background: whitesmoke;
  border-radius: 5px;
}

.table-item-card {
  padding-top: 4px;
  padding-bottom: 4px;
}

.item-footer {
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 24px;
}

.flat-table-item-card {
  padding: 0px;
}

.flat-item-card {
  width: 100%;
  padding: 16px;
  border-radius: 5px;
  background: white;
}

.field-header {
  color: var(--tf-fg-2);
  font-weight: 500;
  font-size: 14px;
}

.field-value {
  color: var(--tf-fg-3);
  font-weight: normal;
  font-size: 16px;
}
</style>

